module.exports = require('component-classes');


// WEBPACK FOOTER //
// ./~/min-dom/lib/classes.js